module.exports = __webpack_public_path__ + "img/b44.d01bd263.png";